module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu/btn_order-2-8e6b0ce29f7207286ceb28ebcbd089b8.png";